import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center pt-20">
      <Seo title="Page Not Found | Glow Green" description="The page you are looking for could not be found." />
      <div className="text-center px-4" data-testid="not-found-page">
        <p className="font-display font-extrabold text-7xl text-leaf">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-forest">This page slipped through the cracks.</h1>
        <p className="mt-2 text-slate-600">Let's get you back to a cleaner place.</p>
        <Link to="/" data-testid="not-found-home-link" className="mt-6 inline-flex rounded-full bg-forest px-6 py-3 font-display font-bold text-sm text-white hover:bg-forest-soft transition-colors">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
